import { z } from "zod";


export const ProcessorSchema = z.object({
    id: z.string(),
    type: z.string(),
    name: z.string(),
    options: z.record(z.string(), z.any()).nullable(),
    createdAt: z.date(),
    enabled: z.boolean(),
    archivedAt: z.date().nullable().optional(),
    payfacProvider: z.string().nullable().optional(),
    supportedCurrencies: z.array(z.string()).nullish(),
});

export const ProcessorDetailsSchema = z.object({
    id: z.string(),
    type: z.string(),
    name: z.string(),
    enabled: z.boolean(),
    options: z.record(z.string(), z.any()).nullable(),
    supportedCurrencies: z.array(z.string()),
    baseCurrency: z.string().nullable(),
    monthlyProcessingCapacity: z.number().nullable(),
    totalProcessedAmount: z.number().nullable(),
    // Lifetime success volume per payment currency, largest first. currency is
    // null only for a processor with no payments and no base currency.
    processedVolumes: z.array(z.object({ currency: z.string().nullable(), amount: z.number() })).optional(),
    approvalRate: z.number().nullable(),
    monthlyApprovalRate: z.number().nullable(),
    // Current-month cap utilisation (base-currency minor units / percentage).
    // null when the processor has no monthly cap set. Optional so existing
    // processor-detail consumers that don't supply them stay structurally valid.
    monthSuccessVolume: z.number().nullable().optional(),
    remainingCapacity: z.number().nullable().optional(),
    capacityUsagePercentage: z.number().nullable().optional(),
    accountId: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    archivedAt: z.date().nullable().optional(),
});

export type Processor = z.infer<typeof ProcessorSchema>;
export type ProcessorDetails = z.infer<typeof ProcessorDetailsSchema>;